import { type ComponentPropsWithoutRef, type FC } from 'react'

import { cn } from '@/utils/tailwind.utils'

type Props = ComponentPropsWithoutRef<'div'>

export const ModalBody: FC<Props> = ({ className, children, ...props }) => {
  return (
    <div {...props} className={cn(['px-6 py-4', className])}>
      {children}
    </div>
  )
}
